import dispatcher from 'js/core/dispatcher';
// import { validateSMS_v1 } from 'js/library/utils/API/validateSMS_v1.js';
import { validateCode } from 'js/library/utils/API/Authentication/validateSMS';

export const codeInputAction = (dispatch, cellPhone, code, transactionId) => {
  return dispatcher(dispatch, 'CODE_INPUT', validateCode(code, cellPhone, transactionId));
};

